import {createSlice, PayloadAction} from '@reduxjs/toolkit';

interface UiState {
  paginationFocusPage: number | null;
}

const initialState: UiState = {
  paginationFocusPage: null,
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setPaginationFocus(state, action: PayloadAction<number>) {
      state.paginationFocusPage = action.payload;
    },
    clearPaginationFocus(state) {
      state.paginationFocusPage = null;
    },
  },
});

export const {setPaginationFocus, clearPaginationFocus} = uiSlice.actions;
export default uiSlice.reducer;
